import { cva } from '@/styled-system/css';

export const inputChipCloseStyles = cva({
  base: {
    'display': 'inline-flex',

    '& > [data-c11n-component="CloseButton"]': {
      marginInlineStart: 'Chip.Close.margin.left',
      height: 'Chip.Close.height',
      width: 'Chip.Close.width',
      padding: 'Chip.Close.padding',
      boxShadow: {
        _focusVisible: 'inset 0 0 0 {borderWidths.default} var(--shadow-color), {shadows.focus}',
      },
      _after: {
        content: '""',
        position: 'absolute',
        height: 'Chip.tapArea',
        minWidth: 'Chip.tapArea',
        width: '100%',
        top: '50%',
        marginTop: 'calc(({sizes.Chip.tapArea} / 2) * -1)',
      },
    },
  },
  variants: {
    disabled: {
      true: {
        '& > [data-c11n-component="CloseButton"]': {
          opacity: 1,
        },
      },
      false: {
        '& > [data-c11n-component="CloseButton"]': {
          backgroundColor: {
            _hover: 'CloseButton.bg.hover',
            _active: 'CloseButton.bg.pressed',
          },
        },
      },
    },
  },
});
